import { render, staticRenderFns } from "./zhiya.vue?vue&type=template&id=e80e5a3c&scoped=true"
import script from "./zhiya.vue?vue&type=script&lang=ts"
export * from "./zhiya.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80e5a3c",
  null
  
)

export default component.exports